<template>
  <page>
    <div>
      <v-card>
        <v-card-title>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNewPaytMeth()"> New Payment Method<v-icon right>mdi-plus</v-icon> </v-btn>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          v-bind:options.sync="pagination"
          item-key="paytmeth"
          :loading="loading"
          :no-data-text="noDataText"
          :custom-filter="customSearch"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.paytmeth }}</td>
              <td class="text-xs-left">{{ row.item.paytmethDesc }}</td>
              <td class="table-action-header">
                <table-action
                  :rowData="row"
                  query
                  @query="doPaytMethQuery(row.item.paytmeth)"
                  review
                  @review="doPaytMethReview(row.item.paytmeth)"
                  remove
                  @remove="doPromptRemove(row.item)"
                ></table-action>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Payment Method? ({{ deletePaytMeth }})
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Payment Method', align: 'left', value: 'paytmeth' },
        { text: 'Description', value: 'paytmethDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        paytmeth: 'Payment Method Code',
        paytmethDesc: 'Payment Method Description'
      },
      filters: {
        paytmeth: undefined,
        paytmethDesc: undefined
      },
      totalItems: 0,
      selectedPaytMeth: undefined,
      deletePaytMeth: '',
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    paytMethMenu() {
      return this.$store.state.paytMethParam.menu
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.paytMethMenu.getList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  paytmeth: datamap.paytmeth,
                  paytmethDesc: datamap.paytmethDesc
                }
                this.items.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.paytmeth = null
      this.filters.paytmethDesc = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doPaytMethReview(paytmeth) {
      this.$router.push({ name: 'paytMethReview', params: { paytmeth: paytmeth } })
    },
    doPaytMethQuery(paytmeth) {
      this.$router.push({ name: 'paytMethQuery', params: { paytmeth: paytmeth } })
    },
    doNewPaytMeth() {
      this.$router.push({ name: 'paytMethReview', params: { paytmeth: 'new' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedPaytMeth = data
        this.deletePaytMeth = data.paytmeth
      }
    },
    async doRemove() {
      const apiURI = this.paytMethMenu.deletePaytMeth
      if (apiURI) {
        const expand = this.selectedPaytMeth
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  mounted() {
    this.doInit(true)
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
